import React from 'react'
import GraphBar from './GraphBar'
import {GraphProps} from './expense-dashboard'

const Graph: React.FC<GraphProps> = ({
    data = {expenseTotal: 0, items: []},
    noReciepts,
    'data-testid': dataTestId
}) => {
    return (
        <div
            data-testid={dataTestId || 'Graph'}
            className="mt-[43px] md:mt-[68px] js-graph-total"
            data-graph-total={data.expenseTotal}
        >
            <div className="flex items-end justify-center relative mb-[32px] md:-mx-15">
                <div className="absolute bottom-[-1px] left-0 w-full h-px bg-[#375481]"></div>
                {data?.items &&
                    data.items.map((item) => (
                        <GraphBar
                            key={item.title}
                            {...item}
                            noReciepts={noReciepts}
                            data-testid={dataTestId || 'Graph-GraphBar'}
                        />
                    ))}
            </div>
        </div>
    )
}

export default Graph
